const DASHBOARD_GLASS_RGB = '16,18,25';
const DASHBOARD_GLASS_MAX_OPACITY = 0.6;
const DASHBOARD_GLASS_MAX_BLUR = 24;

export const getDashboardGlassBackground = (progress: number) => (
  `rgba(${DASHBOARD_GLASS_RGB},${progress * DASHBOARD_GLASS_MAX_OPACITY})`
);

export const getDashboardGlassFilter = (progress: number) => (
  `blur(${progress * DASHBOARD_GLASS_MAX_BLUR}px)`
);

export const DASHBOARD_SCROLLED_GLASS_BACKGROUND = getDashboardGlassBackground(1);
export const DASHBOARD_SCROLLED_GLASS_FILTER = getDashboardGlassFilter(1);
export const DASHBOARD_SCROLLED_GLASS_BORDER = '1px solid rgba(216,163,99,0.10)';
export const DASHBOARD_SCROLLED_GLASS_SHADOW = '0 8px 32px rgba(0,0,0,0.24)';
